import { useCallback } from "react";

/**
 * Сохранение уже полученного из сети файла на диск пользователя.
 *
 * Скачивание запускается кликом по временной ссылке: единственный способ
 * задать имя файла без участия сервера. Приём собран здесь одним местом, чтобы
 * экраны с экспортом (список сайтов, статистика, задача, удаление ссылок
 * конкурентов) не повторяли работу с DOM у себя.
 */
export function useFileDownload(): (blob: Blob, fileName: string) => void {
  return useCallback((blob: Blob, fileName: string) => {
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = blobUrl;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(blobUrl);
  }, []);
}
